export default __webpack_public_path__ + "static/media/Bright HealthCare.df30bafb.png";